import { useThreadUserMentionsVariation } from '#pplx/frontend/apps/ask/generated/assignment-hooks/useThreadUserMentionsVariation.js';
import { useSessionOrgUUID } from '#pplx/frontend/apps/ask/organization/hooks/useSessionOrgUUID.js';
import { useIsEnterpriseUser } from '#pplx/frontend/auth/useIsEnterpriseUser.js';
import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback, useMemo } from 'react';
const userMentionSelectedEvent = EVENT_PAYLOAD;
/** Reads user-mention eligibility and organization context, and records selections for the caller's surface. */
export function useUserMentionContext({ reason, enabled = true, }) {
    const isEnterprise = useIsEnterpriseUser();
    const { variation: userMentionsEnabled } = useThreadUserMentionsVariation({
        defaultValue: false,
    });
    const { uuid: orgUuid } = useSessionOrgUUID();
    const { track } = useInstrumentation();
    const featureEnabled = enabled && isEnterprise && userMentionsEnabled;
    const onSelect = useCallback(() => {
        track(userMentionSelectedEvent({
            name: 'query user mention selected',
            data: { surface: reason },
        }));
    }, [reason, track]);
    return useMemo(() => ({ featureEnabled, orgUuid, onSelect }), [featureEnabled, orgUuid, onSelect]);
}
//# sourceMappingURL=useUserMentionContext.js.map